import React, { useState, useEffect } from 'react'
import birthdayCakeImage from 'images/birthday-cake.png';
import Button from 'components/shared/Button';
import Info from 'components/shared/Info';
import { BirthdayInput } from 'components/shared/Input';
import useProfile from 'sdk/hooks/user/useProfile';
import useUpdateUser from 'sdk/hooks/user/useUpdateUser';
import useUser from 'sdk/hooks/user/useUser';
import useLocation from 'sdk/hooks/useLocation';
import { StringConstant } from 'utils/Constants';
import styles from './SignUp.module.scss';

type BirthdayViewProps = {
  handleNext: () => void,
  tooYoung: (msg: string) => void,
  className?: string,
}

function BirthdayView({
  handleNext,
  tooYoung,
  className,
}: BirthdayViewProps) {
  const [birthday, setBirthday] = useState<Date | null>(null)
  const [error, setError] = useState<boolean>(false)
  const profileData = useProfile(true)
  const locationData = useLocation()
  const userData = useUser()
  const {
    mutate: updateUserMutation,
    data: updateUserData,
    error: updateUserError,
    isSuccess: isUpdateUserSuccess,
    isError: isUpdateUserError,
    isLoading: isUpdateUserLoading,
    reset: resetUpdateUser,
  } = useUpdateUser({ id: userData?.data?.user?.id || '', country: locationData?.data?.country_code2 || 'US' })

  useEffect(() => {
    if (profileData.isSuccess) {
      setBirthday((
        profileData?.data?.birthday
          ? (new Date(profileData?.data?.birthday))
          : null
      ))
    }
  }, [profileData.isSuccess])

  useEffect(() => {
    if (isUpdateUserSuccess) {
      handleNext()
      resetUpdateUser();
    }
  }, [isUpdateUserSuccess, updateUserData])

  useEffect(() => {
    if (isUpdateUserError) {
      // @ts-ignore
      if (updateUserError?.toString()?.includes(StringConstant.SIGN_UP_ELIGIBITY_ERROR)) {
        // @ts-ignore
        tooYoung(updateUserError?.toString())
      } else {
        // @ts-ignore
        console.error(updateUserError?.toString())
      }
    }
  }, [isUpdateUserError])

  const handleChange = (value: Date | null) => {
    setBirthday(value)
    setError(false)
  }

  return (
    <div className={className}>
      <div className={styles.subheader}>Happy birthday! But when is it?</div>

      <img src={birthdayCakeImage} className={styles.birthdayImage} alt="birthday cake" />
        <BirthdayInput
          className={styles.birthdayInput}
          value={birthday}
          onChange={handleChange}
          error={error}
          errorMessage={StringConstant.SIGN_UP_BIRTHDAY_ERROR}
          white
        />
      <Info white>
        <span>
          Your birthday won&apos;t be visible to the public
        </span>
      </Info>

      <Button
        className={styles.margin20}
        disabled={!birthday || isUpdateUserLoading}
        onClick={() => updateUserMutation({
          birthday: ((new Date(birthday ?? '')).toISOString()),
        })}
        loading={isUpdateUserLoading}
        purple
        wide
      >
        Next
      </Button>
    </div>
  )
}

export default BirthdayView
